import Modal from 'react-modal';
import { Building2, Home, Mail, Map, MapPin, User, VenetianMask, LockIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import { useDispatch, useSelector } from 'react-redux';
import { CrossSvg, LeftArrowSvg } from '../../assets/svg';
import { toaster } from '../../services/toast-service';
import AuthBg from '../../assets/images/auth/auth-bg.png';
import LogoCircle from '../../assets/images/logo/logo.png';
import * as AuthActions from '../../redux/actions/authAction';
import { INDIAN_STATES, CITIES_BY_STATE } from '../../utils/indianLocations';

import 'react-phone-input-2/lib/style.css';
Modal.setAppElement('#root');

const SignupModal = () => {
    const dispatch = useDispatch();
    const { isSignupModalOpen } = useSelector(state => state?.authReducer);
    const handleCloseModal = () => dispatch(AuthActions.toggleSignupModal(false));

    const [mobileNumber, setMobileNumber] = useState({ mobile_number: '', country_code_length: '' });
    const handleMobileNumber = (value, country) => {
        setMobileNumber({ mobile_number: value, country_code_length: country?.dialCode?.length });
        // Auto-set country based on dialing code
        if (country?.dialCode === '91') {
            setInputField(prev => ({ ...prev, country: 'India', state: '', city: '' }));
        } else if (country?.name) {
            setInputField(prev => ({ ...prev, country: country.name, state: '', city: '' }));
        }
    };

    const [inputField, setInputField] = useState({ first_name: '', last_name: '', email: '', password: '', gender: '', country: 'India', state: '', city: '', address: '', pincode: '' });
    const handleInputField = (e) => setInputField({ ...inputField, [e.target.name]: e.target.value }); //* Handle Input Field : Login

    //* Handle Validation For Intake Form Data
    const handleValidation = () => {
        const { first_name, last_name, email, gender, country, state, city, address, pincode } = inputField;
        let isValid = true;

        if (!first_name) {
            toaster.warning({ text: 'Please enter first name' });
            return isValid = false
        }

        if (!email) {
            toaster.warning({ text: 'Please enter email' });
            return isValid = false
        }

        return isValid;
    };

    //! Handle Submit : Login
    const handleSubmit = () => {
        const mobile_number = String(mobileNumber?.mobile_number);
        const country_code_length = mobileNumber?.country_code_length;
        const { first_name, last_name, email, gender, country, state, city, address, pincode, password } = inputField;
        const phone = mobile_number?.substring(country_code_length);
        const country_code = mobile_number?.substring(0, country_code_length);

        console.log({ first_name, last_name, email, gender, country, state, city, address, pincode, phone, country_code, password });

        const payload = {
            data: { firstName: first_name, lastName: last_name, email, gender, country, state, city, address, password, pincode, phone, countryCode: country_code },
            onComplete: () => {
                handleCloseModal();
                setMobileNumber({ mobile_number: '' });
                setInputField({ first_name: '', last_name: '', email: '', gender: '', password: '', country: '', state: '', city: '', address: '', pincode: '' });
            }
        };

        //! Dispatching API
        if (handleValidation()) dispatch(AuthActions.customerSignup(payload));
    };

    const [minHeight, setMinHeight] = useState('initial');
    useEffect(() => {
        const handleResize = () => setMinHeight(window.innerHeight * 0.95);

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <Modal isOpen={isSignupModalOpen} className="modal-content" onRequestClose={handleCloseModal} overlayClassName="modal-overlay" closeTimeoutMS={200} style={{ content: { minHeight: minHeight, backgroundColor: 'transparent' } }}>
                <section className="relative flex items-center justify-center max-md:p-5 bg-white rounded-lg">
                    <div onClick={() => handleCloseModal()} className='absolute bg-red-600 text-white p-1 rounded-full right-5 top-5 cursor-pointer'><CrossSvg /></div>

                    <article className="rounded-lg overflow-hidden max-w-4xl w-full">
                        <main className="rounded-lg max-w-4xl w-full py-5 flex bg-contain bg-center bg-no-repeat" style={{ backgroundImage: `url(${AuthBg})` }}>
                            <div className='basis-full flex flex-col'>
                                <div className='min-h-24 max-h-24'><img className="object-contain h-full w-full" src={LogoCircle} /></div>

                                <div className='flex flex-col gap-5 px-10 py-5'>
                                    <div className='flex items-center gap-3'><div onClick={() => handleCloseModal()} className='pt-0.5 cursor-pointer'><LeftArrowSvg /></div> <h6 className='text-black text-2xl font-medium text-center tracking-tight'>Register</h6></div>
                                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                                        <div className="flex items-center border p-2 rounded bg-white">
                                            <span className="mr-3 text-gray-500"><User className="w-5 h-5" /></span>
                                            <input type="text" name="first_name" placeholder="Enter Your First Name" value={inputField?.first_name} onChange={handleInputField} className="w-full outline-none" />
                                        </div>

                                        <div className="flex items-center border p-2 rounded bg-white">
                                            <span className="mr-3 text-gray-500"><User className="w-5 h-5" /></span>
                                            <input type="text" name="last_name" placeholder="Enter Your Last Name" value={inputField?.last_name} onChange={handleInputField} className="w-full outline-none" />
                                        </div>

                                        <div className="flex items-center border p-2 rounded bg-white">
                                            <span className="mr-3 text-gray-500"><Mail className="w-5 h-5" /></span>
                                            <input type="text" name="email" placeholder="Enter Your Email" value={inputField?.email} onChange={handleInputField} className="w-full outline-none" />
                                        </div>

                                        <div className="flex items-center border p-2 rounded bg-white h-[42px]">
                                            <span className="mr-3 text-gray-500 flex items-center justify-center">
                                                <VenetianMask className="w-5 h-5" />
                                            </span>
                                            <select name="gender" value={inputField?.gender} onChange={handleInputField} className="w-full outline-none bg-transparent">
                                                <option value="" disabled>Select Gender</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                                <option value="other">Other</option>
                                            </select>
                                        </div>

                                        <PhoneInput
                                            country={'in'}
                                            placeholder='Enter mobile no'
                                            value={mobileNumber?.mobile_number}
                                            onChange={handleMobileNumber}
                                            disableCountryCode={false}
                                            countryCodeEditable={false}
                                            disableDropdown={false}
                                            inputStyle={{ width: '100%', height: '42px', fontSize: "15px", backgroundColor: "#FFF", borderRadius: '4px' }}
                                        />

                                        <div className="flex items-center border p-2 rounded bg-white">
                                            <span className="mr-3 text-gray-500"><LockIcon className="w-5 h-5" /></span>
                                            <input type="text" name="password" placeholder="Enter Your Password" value={inputField?.password} onChange={handleInputField} className="w-full outline-none" />
                                        </div>

                                        <div className="flex items-center border p-2 rounded bg-white h-[42px]">
                                            <span className="mr-3 text-gray-500"><Map className="w-5 h-5" /></span>
                                            <input type="text" name="country" placeholder="Country" value={inputField?.country} onChange={e => setInputField(prev => ({ ...prev, country: e.target.value, state: '', city: '' }))} className="w-full outline-none" />
                                        </div>

                                        {inputField?.country === 'India' ? (
                                            <div className="flex items-center border p-2 rounded bg-white h-[42px]">
                                                <span className="mr-3 text-gray-500"><Map className="w-5 h-5" /></span>
                                                <select name="state" value={inputField?.state} onChange={e => setInputField(prev => ({ ...prev, state: e.target.value, city: '' }))} className="w-full outline-none bg-transparent">
                                                    <option value="">Select State</option>
                                                    {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                                                </select>
                                            </div>
                                        ) : (
                                            <div className="flex items-center border p-2 rounded bg-white">
                                                <span className="mr-3 text-gray-500"><Map className="w-5 h-5" /></span>
                                                <input type="text" name="state" placeholder="Enter Your State" value={inputField?.state} onChange={handleInputField} className="w-full outline-none" />
                                            </div>
                                        )}

                                        {inputField?.country === 'India' && inputField?.state ? (
                                            <div className="flex items-center border p-2 rounded bg-white h-[42px]">
                                                <span className="mr-3 text-gray-500"><Building2 className="w-5 h-5" /></span>
                                                <select name="city" value={inputField?.city} onChange={handleInputField} className="w-full outline-none bg-transparent">
                                                    <option value="">Select City</option>
                                                    {(CITIES_BY_STATE[inputField.state] || []).map(c => <option key={c} value={c}>{c}</option>)}
                                                </select>
                                            </div>
                                        ) : (
                                            <div className="flex items-center border p-2 rounded bg-white">
                                                <span className="mr-3 text-gray-500"><Building2 className="w-5 h-5" /></span>
                                                <input type="text" name="city" placeholder="Enter Your City" value={inputField?.city} onChange={handleInputField} className="w-full outline-none" />
                                            </div>
                                        )}

                                        <div className="flex items-center border p-2 rounded bg-white">
                                            <span className="mr-3 text-gray-500"><MapPin className="w-5 h-5" /></span>
                                            <input type="text" name="pincode" placeholder="Enter Your Pincode" value={inputField?.pincode} onChange={handleInputField} className="w-full outline-none" />
                                        </div>

                                    </div>
                                    <div className="flex items-center border p-2 rounded bg-white">
                                        <span className="mr-3 text-gray-500"><Home className="w-5 h-5" /></span>
                                        <input type="text" name="address" placeholder="Enter Your Address" value={inputField?.address} onChange={handleInputField} className="w-full outline-none" />
                                    </div>

                                    <button onClick={handleSubmit} className="w-full shadow-lg bg-primary hover:bg-orange-600 focus:shadow-outline focus:outline-none text-white py-2 px-4 rounded transition duration-300 transform" type="submit">Sign Up</button>

                                    <div className='text-[14px] font-[500] flex items-center justify-center gap-2'>Already have an account?
                                        <div onClick={() => {
                                            handleCloseModal();
                                            dispatch(AuthActions.toggleLoginModal(true));
                                        }} className='underline text-[#0858F7] cursor-pointer'>Sign In</div>
                                    </div>

                                    <div className='text-xs text-center font-[500] text-[#0858F7]'>By Signup, you agree to our <Link to={'/terms-of-use'} onClick={() => handleCloseModal()} className='underline'>Terms of Use</Link> and <Link to={'/privacy-policy'} onClick={() => handleCloseModal()} className='underline'>Privacy Policy</Link></div>
                                </div>
                            </div>
                        </main>
                    </article>
                </section>
            </Modal>
        </>
    )
}

export default SignupModal;